import { render, staticRenderFns } from "./ApprovalLineItemChanges.vue?vue&type=template&id=94a8927a"
import script from "./ApprovalLineItemChanges.vue?vue&type=script&lang=js"
export * from "./ApprovalLineItemChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports